import { useCallback } from 'react';

import {
    getFilterResetData,
    mergeFilterActionList,
} from 'component/Search/Filter/Active/helper/getFilterResetData';

import { useResetChangedFilterList } from 'hooks/form/useChangedFilterList';
import { useSetSearchAtom } from 'hooks/form/useSetSearchAtom';

import { currentSearchAtom } from 'data/Atom/Search';

import { convertUrlToSearch } from 'utility/Convert/Search/urlToSearch';
import {
    getCurrentUrlWithoutParams,
    removeURLParam,
} from 'utility/Provide/Url';

import { ActiveFilter, FilterAction } from 'proto/Search/ActiveFilter';

export const useActiveFilter = () => {
    const setCurrentSearch = useSetSearchAtom(currentSearchAtom);
    const resetChangedFilterList = useResetChangedFilterList();
    const kiFilter = 'kiFilter';

    const removeActiveFilterFromSearch = useCallback(
        (filterActionList: FilterAction[]) => {
            if (filterActionList.length) {
                resetChangedFilterList();
                setCurrentSearch((current) => {
                    const filterResetData =
                        getFilterResetData(filterActionList);
                    let updatedParams = removeURLParam(
                        filterResetData.currentSearchParams,
                        'page'
                    );
                    if (
                        updatedParams.has(kiFilter) &&
                        !updatedParams.get(kiFilter)?.trim()
                    ) {
                        updatedParams = removeURLParam(updatedParams, kiFilter);
                    }

                    const params = updatedParams.toString();
                    const baseUrl = getCurrentUrlWithoutParams();
                    const newUrl = `${baseUrl}?${params}`;

                    return convertUrlToSearch({
                        searchUrl: newUrl,
                        destinationLabel: current.destination.label,
                        pageCount: current.pagination.pageCount,
                    });
                });
            }
        },
        [setCurrentSearch, resetChangedFilterList]
    );

    const removeAllActiveFilterFromSearch = useCallback(
        (activeFilterList: ActiveFilter[]) => {
            const filterActionList = mergeFilterActionList(activeFilterList);
            removeActiveFilterFromSearch(filterActionList);
        },
        [removeActiveFilterFromSearch]
    );

    return {
        removeActiveFilterFromSearch,
        removeAllActiveFilterFromSearch,
    };
};
